import { Box, Chip, LinearProgress, linearProgressClasses, Stack } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import styled from "styled-components";

const BadgeBackground = styled(Stack)`
    width: 90px;
    height: 90px;
    background-color: #424242;
    padding: 9px;
    border-radius: 14px;
`;

const BadgeBackgroundEarned = styled(Stack)`
    width: 90px;
    height: 90px;
    background-color: #424242;
    padding: 6px;
    border-radius: 14px;
    border-style: solid;
    border-color: ${({ theme }) => theme.palette.primary.main};
`;

const DayEarnedLetters = styled.h5`
    font-size: 10px;
    font-weight: 300;
    margin: 0;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const BadgesDescriptionLetters = styled.h4`
    font-size: 12px;
    font-weight: 200;
    margin: 0;
`;

const HelperLetters = styled.h3`
    font-size: 14px;
    font-weight: 300;
    margin: 0;
`;

const TierChip = styled(Chip)`
    z-index: 100;
    background: #000000ad;
    border-radius: 4px;
`;

const ProgressLetters = styled.h1`
    font-size: 12px;
    font-weight: 300;
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 18,
    width: "100%",
    backgroundColor: "#505050",
    borderRadius: 6,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: "linear-gradient(to right, #59C36A, #4caf5024)",
    },
}));

const TierChipAssign = ({ achievement }) => {
    if (achievement && achievement.achievementId.includes("tier2")) {
        return <TierChip size="small" label="Tier II" />;
    }
    if (achievement && achievement.achievementId.includes("tier3")) {
        return <TierChip size="small" label="Tier III" />;
    }
    if (achievement && achievement.achievementId.includes("tier4")) {
        return <TierChip size="small" label="Tier IV" />;
    }
    if (achievement && achievement.achievementId.includes("tier5")) {
        return <TierChip size="small" label="Tier V" />;
    }
    return null;
};

const BadgeFull = ({ achievement }) => {
    if (!achievement) return null;

    const isProd = process.env.ENVIRONMENT_NAME === "prod";
    const setAssetLink = () => {
        if (!isProd) return "https://assets-sit.adadot.com/achievements";
        return "https://assets.adadot.com/achievements";
    };

    const assetLink = setAssetLink();

    return (
        <Stack key={achievement.name} direction="row" alignItems="center" pb={2} width="320px">
            {(achievement && !achievement.progress) ||
            (achievement && achievement.progress.completed === false) ? (
                <BadgeBackground direction="column" spacing={-3}>
                    <Box
                        component="img"
                        sx={{
                            height: "72px",
                            width: "72px",
                            borderRadius: "6px",
                        }}
                        src={`${assetLink}/${achievement.category}/${achievement.achievementId}.png`}
                        loading="lazy"
                    />
                    {TierChipAssign({ achievement })}
                </BadgeBackground>
            ) : (
                <BadgeBackgroundEarned spacing={-3}>
                    <Box
                        component="img"
                        sx={{
                            height: "72px",
                            width: "72px",
                            borderRadius: "6px",
                        }}
                        src={`${assetLink}/${achievement.category}/${achievement.achievementId}.png`}
                        loading="lazy"
                    />
                    {TierChipAssign({ achievement })}
                </BadgeBackgroundEarned>
            )}
            <Stack direction="column" pl={1} pr={2}>
                <HelperLetters>{achievement.name}</HelperLetters>
                <BadgesDescriptionLetters>{achievement.description}</BadgesDescriptionLetters>
                {achievement.progress &&
                    achievement.progress.updatedAt !== null &&
                    achievement.progress.completed !== false && (
                        <DayEarnedLetters>
                            Earned on{" "}
                            {format(new Date(achievement.progress.updatedAt) * 1000, "PPP")}
                        </DayEarnedLetters>
                    )}
                {achievement.target &&
                    achievement.progress &&
                    achievement.progress.progress !== 0 &&
                    achievement.progress.completed === false && (
                        <div
                            style={{
                                width: "180px",
                                marginTop: "6px",
                                position: "relative",
                            }}
                        >
                            <BorderLinearProgress
                                variant="determinate"
                                value={(achievement.progress.progress / achievement.target) * 100}
                            />
                            <ProgressLetters>
                                {achievement.progress.progress} / {achievement.target}
                            </ProgressLetters>
                        </div>
                    )}
            </Stack>
        </Stack>
    );
};
export default BadgeFull;
